// Module
var code = `<h2 class="section-header">Please confirm the following:</h2>
<form name="\$ctrl.form">
  <table class="table">
    <tbody>
    <tr>
      <td>Product group:</td>
      <td>
        <select required
                ng-options="o as o | prettyEnum for o in \$ctrl.groupOptions"
                ng-model="\$ctrl.group">
        </select>
      </td>
    </tr>
    <tr>
      <td>Content:</td>
      <td>
        <file-upload ng-model="\$ctrl.contentFile"
                     required
                     validate-uploaded
                     max-files="1"
                     show-file-name="true"
                     show-remarks="false"
                     enable-webcam="false">
        </file-upload>
      </td>
    </tr>
    </tbody>
  </table>

  <div class="summary-actions">
    <button
      type="submit"
      class="btn btn-success"
      ng-disabled="\$ctrl.form.\$invalid"
      ng-click="\$ctrl.execute()">
      Execute
    </button>
  </div>
</form>
`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/support/misc/upload-custom-product-categories/upload-custom-product-categories.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;